import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { GenericService } from '../../commons/generic.service';
import { environment } from 'environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DadosPessoaisPosRecadDto } from "../../components/pos-recadastramento/aba1-posrecad/dadosPessoaisPosRecad.dto";
import { ArquivoBlobDTO } from 'app/model/arquivoBlob.dto';


@Injectable()
export class PosCampanhaServiceAba3 extends GenericService {

    private baseUrl = environment.url + 'api/v1';

    constructor(http: HttpClient) {
        super(http);
    } 
    
    getDadosAuxSaude(param): Observable<DadosPessoaisPosRecadDto> {
        return this.getMethod<DadosPessoaisPosRecadDto>(`api/v1/admin/validacao-recadastramento/aux-saude`, { validacaoRecadId: param });
    }

    getArquivoAuxSaudeTitular(mes, id, isTitular): Observable<any> {
        const options = {
            responseType: 'blob' as 'json'
          };
        return this.http.get<ArquivoBlobDTO>(this.url +`api/v1/admin/validacao-recadastramento/aux-saude/${mes}/${id}/${isTitular}`, options);
    }

    getArquivoAuxSaude(mes, id, isTitular): Observable<any> {
        const options = {
            responseType: 'blob' as 'json'
          };
        return this.http.get<ArquivoBlobDTO>(this.url +`api/v1/admin/validacao-recadastramento/aux-saude/${mes}/${id}/${isTitular}`, options);
    }

    postAuxSaude(body): Observable<any> {
        return this.postMethod<any>(body, `api/v1/admin/validacao-recadastramento/aux-saude`);
    }

}  
